<template>
  <div class="mb-4">
    <button
      @click="openNotificationPage"
      class="header-section flex items-center text-base font-medium cursor-pointer h-11 hover:text-red-600 hover:fill-red-600 w-full relative"
      :class="{
        'bg-v4 hover:bg-v4 border-left text-red-600 fill-red-600': isNotificationPanelActive,
          'fill-color-v4 text-color-v4': !isNotificationPanelActive
      }"
    >

      <fluent-icon icon="alert" size="20" class="icon icon--font ml-4 mr-4" />
      <span
        class="text-button flex items-start font-medium text-button w-40 ml-3"
        >{{ $t('Notificações') }}
      </span>
      <span
        class="text-black-900 bg-yellow-300 absolute button-counted p-1 text-xxs min-w-[1rem] rounded-full"
        v-if="unreadCount"
      >
        {{ unreadCount }}
      </span>
    </button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      notificationMetadata: 'notifications/getMeta',
    }),
    unreadCount() {
      console.log(this.notificationMetadata.unreadCount);
      if (!this.notificationMetadata.unreadCount) {
        return '';
      }

      return this.notificationMetadata.unreadCount < 100
        ? `${this.notificationMetadata.unreadCount}`
        : '99+';
    },
    isNotificationPanelActive() {
      return this.$route.name === 'notifications_index';
    },
  },
  methods: {
    openNotificationPage() {
      if (this.$route.name !== 'notifications_index') {
        this.$router.push({
          name: 'notifications_index',
        });
      }
    },
  },
};
</script>

<style scoped>
.border-left {
  border-left: 2px solid #E30613;
}

.border-div {
  border-bottom: 6px solid #eee;
}

.text-color-v4 {
  color: #484848
}

.fill-color-v4{
  fill: #484848
}

.bg-v4{
  background: #E0E0E0;
}

.button-counted{
  top: 6px;
  right: 4px;
  height: 30px;
}
</style>
